import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18n from '@/common/agent/i18n';
import Field from '@/common/view/form/Field';
import Input from '@/common/view/form/Input';
import { normalizeLoginId } from '@/common/util/formatUtil';
import { LoginForm } from '../model/AuthTypes';

const LoginIdFieldView: React.FC = () => {
  const { register, getFieldState, formState } = useFormContext<LoginForm>();
  const { error } = getFieldState('id', formState);

  const { onChange, ...rest } = register('id');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = normalizeLoginId(e.target.value);
    onChange(e);
  };

  return (
    <Field hideLabelSpacing error={error?.message}>
      <Input {...rest} onChange={handleChange} placeholder={i18n.t('form.id.placeholder')} error={!!error} />
    </Field>
  );
};

export default LoginIdFieldView;
